module.exports = __webpack_public_path__ + "img/lightbulb.c1d78e07.svg";